import config from '@/config'

const TOKEN_KEYS = {
  ACCESS: config.system.accessTokenKey,
  REFRESH: config.system.refreshTokenKey,
}

export const setAccessToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEYS.ACCESS, token)
}

export const setRefreshToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEYS.REFRESH, token)
}

export const getAccessToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEYS.ACCESS)
}

export const getRefreshToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEYS.REFRESH)
}

export const clearTokens = (): void => {
  localStorage.removeItem(TOKEN_KEYS.ACCESS)
  localStorage.removeItem(TOKEN_KEYS.REFRESH)
}
